import { views } from '../constants';

const { PRIVATE, PUBLIC } = views;

export default (response, view, selectedWishlistId, locale) => {
    let wishlistsList = [];

    response.GiftList.forEach((wishlist) => {
        const name = wishlist.primary === 'true' || wishlist.primary === true ? wishlist.extendedName : wishlist.descriptionName;
        wishlistsList.push({
            id: wishlist.uniqueID,
            name: name,
            totalItems: wishlist.itemCount,
            isPrivate: wishlist.accessSpecifier ? wishlist.accessSpecifier.toUpperCase() === PRIVATE : false,
            isPrimary: wishlist.primary === 'true' || wishlist.primary === true,
            href: `/${locale}/wishlist/${wishlist.uniqueID}`,
            selected: (view === PUBLIC || view === PRIVATE) && selectedWishlistId === wishlist.uniqueID ? 'selected' : '',
        });
    });

    return wishlistsList;
};
